import { render, staticRenderFns } from "./search_user.vue?vue&type=template&id=1954a937&scoped=true&"
import script from "./search_user.vue?vue&type=script&lang=js&"
export * from "./search_user.vue?vue&type=script&lang=js&"
import style0 from "./search_user.vue?vue&type=style&index=0&id=1954a937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954a937",
  null
  
)

export default component.exports